import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableHeaderCellContainer } from '../styled';
import { Tooltip } from 'antd';

const TableHeaderCell = ({
  titleKey,
  args,
  className,
  tooltipContent,
}: {
  titleKey: string;
  args?: Record<string, unknown>;
  className?: string;
  tooltipContent?: string;
}) => {
  const { t } = useTranslation();
  return tooltipContent ? (
    <Tooltip title={tooltipContent}>
      <TableHeaderCellContainer className={className}>{t(titleKey, args)} </TableHeaderCellContainer>
    </Tooltip>
  ) : (
    <TableHeaderCellContainer className={className}>{t(titleKey, args)} </TableHeaderCellContainer>
  );
};

export default TableHeaderCell;
